import React from 'react';
import Card from '../../../core/layout/Card';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import EmailTemplateListFilterContainer from './EmailTemplateListFilterContainer';
import EmailTemplateListContainer from './EmailTemplateListContainer';

const EmailTemplateListScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        ...(props.location.state && props.location.state.from
          ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
          : []),
        { text: 'Email Templates' },
      ]}
    />
    <Card
      title="Email Templates"
      actions={
        <Button
          type="primary"
          icon="plus"
          label="New Email Template"
          onClick={() => browserHistory.push('/email-templates/new')}
        />
      }
    >
      <EmailTemplateListFilterContainer initialFilters={props.location.query} />
      <EmailTemplateListContainer />
    </Card>
  </div>
);

export default EmailTemplateListScene;
